import {
  buildUsagePriceLookup,
  defaultPricePerUnit,
  estimateTokenCostUsd,
  managedAiDefaultPrices,
} from "../../shared/connectorUsagePricing";

export {
  buildUsagePriceLookup,
  defaultPricePerUnit,
  estimateTokenCostUsd,
  managedAiDefaultPrices,
};

export type ConnectorUsageRow = {
  connectorId: string;
  measure: string;
  dimension: string | null;
  value: number | null;
  source?: string | null;
};

// The USD amount is stored per single metered unit; the pricing UI enters and
// displays it scaled by each measure's natural unit (per 1M tokens, per 1K
// requests, per GB). A measure absent from this map has no priceable unit.
export const MEASURE_UNIT: Record<
  string,
  { per: number; label: string; name: string }
> = {
  input_tokens: { per: 1_000_000, label: "$/1M tokens", name: "Input" },
  output_tokens: { per: 1_000_000, label: "$/1M tokens", name: "Output" },
  cache_read_tokens: {
    per: 1_000_000,
    label: "$/1M tokens",
    name: "Cache read",
  },
  cache_write_tokens: {
    per: 1_000_000,
    label: "$/1M tokens",
    name: "Cache write",
  },
  requests: { per: 1_000, label: "$/1K requests", name: "Requests" },
  bytes_in: { per: 1_000_000_000, label: "$/GB", name: "Data in" },
  bytes_out: { per: 1_000_000_000, label: "$/GB", name: "Data out" },
};

export const TOKEN_MEASURES: ReadonlySet<string> = new Set([
  "input_tokens",
  "output_tokens",
  "cache_read_tokens",
  "cache_write_tokens",
]);
